import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { Grid, TextField } from "@material-ui/core";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import Snackbar from "@material-ui/core/Snackbar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import { observer } from "mobx-react";
import { updatePlaylistsForSong } from "../api_utilities/spotify";

import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

const useStyles = (theme) => ({
  root: {
    listStyle: "none",
  },
  spaceBelow: {
    marginBottom: theme.spacing(3),
  },
  tag: {
    marginBottom: theme.spacing(1),
  },
});

const TagDialog = observer(
  class TagDialog extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        snackbarOpen: false,
        snackbarError: false,
        snackbarMessage: "",
        speedDialOpen: false,
        addTagTextFieldVisible: false,
        newTagValue: "",
      };
    }

    deleteTag = (tag_id) => {
      const { onTagsUpdatedOptimistic, trackAndAlbumInfo, store } = this.props;

      const newTags = trackAndAlbumInfo.tags.filter(
        (prevTag) => prevTag.id !== tag_id
      );

      onTagsUpdatedOptimistic(
        trackAndAlbumInfo.albumIndex,
        trackAndAlbumInfo.trackIndex,
        newTags
      );

      if (trackAndAlbumInfo.trackID === store.currentlyPlayingTrack.trackID) {
        store.setCurrentlyPlayingTrackTags(newTags);
      } else {
        store.tagTrack(trackAndAlbumInfo.trackID, newTags);
      }

      const url = new URL(backendBaseURL + "/song/delete_tag");
      makeBackendAPIRequest({
        url: url,
        method: "POST",
        body: { tag_id: tag_id },
        onSuccessCallback: (data) => {
          this.setState({
            snackbarOpen: true,
            snackbarError: false,
            snackbarMessage: "Successfully Removed Tag",
          });

          updatePlaylistsForSong(
            trackAndAlbumInfo.trackID,
            data.add_to_playlists,
            data.remove_from_playlists,
            data.remove_song_spotify_ids
          );
        },
        onFailureCallback: () => {
          this.setState({
            snackbarOpen: true,
            snackbarError: true,
            snackbarMessage: "Failed to Delete Tag",
          });
        },
      });
    };

    addTags = (tagString) => {
      const { onTagsUpdatedOptimistic, trackAndAlbumInfo, store } = this.props;

      let newTagNames = tagString.split(",");
      const existingTagNames = trackAndAlbumInfo.tags.map(
        (tagObject) => tagObject.name
      );

      newTagNames = newTagNames.filter(
        (tag) => existingTagNames.indexOf(tag) === -1
      );

      if (newTagNames.length === 0) {
        return;
      }

      const url = new URL(backendBaseURL + "/song/add_tags");
      makeBackendAPIRequest({
        url: url,
        method: "POST",
        body: {
          id_spotify: trackAndAlbumInfo.trackID,
          tag_names: newTagNames.join(","),
          id_album_spotify: trackAndAlbumInfo.albumID,
          album_total_tracks: trackAndAlbumInfo.albumTotalTracks,
          album_name: trackAndAlbumInfo.albumName,
          release_year: trackAndAlbumInfo.releaseYear,
          album_art_url: trackAndAlbumInfo.albumArtURL,
          album_artists: trackAndAlbumInfo.albumArtists,
          song_name: trackAndAlbumInfo.trackName,
          duration_ms: trackAndAlbumInfo.trackLength,
          track_number: trackAndAlbumInfo.trackNumber,
        },
        onSuccessCallback: (data) => {
          this.setState({
            snackbarOpen: true,
            snackbarError: false,
            snackbarMessage: "Successfully addded Tag(s)",
          });

          const newTags = trackAndAlbumInfo.tags.concat(data.tags);

          onTagsUpdatedOptimistic(
            trackAndAlbumInfo.albumIndex,
            trackAndAlbumInfo.trackIndex,
            newTags
          );

          if (
            trackAndAlbumInfo.trackID === store.currentlyPlayingTrack.trackID
          ) {
            store.setCurrentlyPlayingTrackTags(newTags);
          } else {
            store.tagTrack(trackAndAlbumInfo.trackID, newTags);
          }

          updatePlaylistsForSong(
            trackAndAlbumInfo.trackID,
            data.add_to_playlists,
            data.remove_from_playlists,
            data.remove_song_spotify_ids
          );
        },
        onFailureCallback: () => {
          this.setState({
            snackbarOpen: true,
            snackbarError: true,
            snackbarMessage: "Failed to Add Tag(s)",
          });
        },
      });

      this.setState({ addTagTextFieldVisible: false, newTagValue: "" });
    };

    closeSpeedDial = () => {
      this.setState({ speedDialOpen: false });
    };

    openSpeedDial = () => {
      this.setState({ speedDialOpen: true });
    };

    clickSpeedDial = () => {
      this.setState({ addTagTextFieldVisible: true });
    };

    updateNewTagValue = (event) => {
      this.setState({ newTagValue: event.target.value });
    };

    onNewTagValueKeyDown = (event) => {
      if (event.key === "Enter") {
        this.addTags(event.target.value);
      }
    };

    onDialogClose = () => {
      const { onClose } = this.props;
      onClose();
      setTimeout(() => this.setState({ addTagTextFieldVisible: false }), 1000);
    };

    render() {
      const { classes, isOpen, trackAndAlbumInfo, store } = this.props;
      const {
        snackbarOpen,
        snackbarError,
        snackbarMessage,
        speedDialOpen,
        addTagTextFieldVisible,
        newTagValue,
      } = this.state;

      return (
        <div>
          <Dialog
            open={isOpen}
            onClose={this.onDialogClose}
            className={classes.root}
          >
            <DialogTitle>
              <Typography noWrap>
                Tags for {trackAndAlbumInfo.trackName}
              </Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.spaceBelow}>
                Add tags to tracks to generate custom playlists.
              </DialogContentText>
              <Grid container>
                <Grid item xs={9} className={classes.spaceBelow}>
                  {trackAndAlbumInfo.tags != null ? (
                    trackAndAlbumInfo.tags.map((tag) => {
                      return (
                        <li key={tag.id}>
                          <Chip
                            icon={<LocalOfferIcon />}
                            label={tag.tag_name}
                            onDelete={() => this.deleteTag(tag.id)}
                            className={classes.tag}
                          />
                        </li>
                      );
                    })
                  ) : (
                    <div />
                  )}
                </Grid>
                {addTagTextFieldVisible ? (
                  <Grid item xs={12} className={classes.spaceBelow}>
                    <TextField
                      autoFocus
                      fullWidth
                      value={newTagValue}
                      onChange={this.updateNewTagValue}
                      onKeyDown={this.onNewTagValueKeyDown}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={3} className={classes.spaceBelow}>
                    <SpeedDial
                      ariaLabel="SpeedDial for adding tags"
                      icon={<SpeedDialIcon />}
                      onClick={this.clickSpeedDial}
                      onClose={this.closeSpeedDial}
                      onOpen={this.openSpeedDial}
                      open={speedDialOpen}
                    >
                      {store.tagsForUser.map((tag) => (
                        <SpeedDialAction
                          key={tag}
                          icon={<LocalOfferIcon />}
                          tooltipTitle={tag}
                          tooltipOpen={speedDialOpen}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.addTags(tag);
                          }}
                          name={"speed-dial-child"}
                        />
                      ))}
                    </SpeedDial>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
          </Dialog>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => {
              this.setState({ snackbarOpen: false });
            }}
          >
            {snackbarError ? (
              <Alert
                onClose={() => {
                  this.setState({ snackbarOpen: false });
                }}
                severity="error"
              >
                {snackbarMessage}
              </Alert>
            ) : (
              <Alert
                onClose={() => {
                  this.setState({ snackbarOpen: false });
                }}
                severity="success"
              >
                {snackbarMessage}
              </Alert>
            )}
          </Snackbar>
        </div>
      );
    }
  }
);

export default withStyles(useStyles)(TagDialog);
